var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconEyeOpened(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon_eye_24px",
    "data-name": "icon/eye_24px",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Boundary",
    width: 24,
    height: 24,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_3926",
    "data-name": "Path 3926",
    d: "M1012.58,463.393h0c-1.359-1.881-4.991-6.256-9.371-6.256s-8.013,4.375-9.371,6.257a2.235,2.235,0,0,0,0,2.485c1.358,1.882,4.989,6.258,9.371,6.258s8.012-4.376,9.371-6.258A2.235,2.235,0,0,0,1012.58,463.393ZM1011.363,465c-1.223,1.694-4.465,5.635-8.154,5.635s-6.932-3.941-8.155-5.635a.742.742,0,0,1,0-.73c1.223-1.7,4.467-5.635,8.155-5.635s6.931,3.94,8.154,5.635A.742.742,0,0,1,1011.363,465Zm-8.358-3.573a3.135,3.135,0,1,0,3.114,3.135A3.124,3.124,0,0,0,1003.005,461.428Z",
    transform: "translate(-991.209 -452.637)",
    fill: "#101820"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEyeOpened);
export default __webpack_public_path__ + "static/media/icon_eye_opened.4bfe341525bacccd781f9f5781021bea.svg";
export { ForwardRef as ReactComponent };